export default __webpack_public_path__ + "098de63.png";